module.exports = __webpack_public_path__ + "static/media/spinning-coin-2.aef381fb.gif";